import { messages } from './../../mock-api/common/messages/data';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, map, Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WithdrawService {
    private _data: BehaviorSubject<any> = new BehaviorSubject(null);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    private api: string = environment.api;

    constructor(private _httpClient: HttpClient) {}

    get data$(): Observable<any> {
        return this._data.asObservable();
    }

    getWithdrawaltransactions(take: number, skip: number): Observable<any> {
        return this._httpClient
            .get(`${this.api}/withdraw?take=${take}&skip=${skip}`)
            .pipe(
                map((response: any) => {
                    let result: any = [];
                    result = this.mapResult(response?.withdraws?.actions);
                    return { result, count: response?.withdraws?.count };
                }),
                tap((response: any) => {
                    this._data.next(response);
                })
            );
    }
    getWithdrawTransaction(id: string) {
        return this._httpClient.get(`${this.api}/withdraw/${id}`).pipe(
            map((response: any) => {
                let result: any = [];
                result = this.mapResult(response?.withdraw);
                return { result };
            })
        );
    }
    private mapResult(array: Array<any>): Array<any> {
        let result = [];

        array.forEach((element) => {
            result.push({
                ...element,
                withdrawId: element?.withdrawId,
                merchant: element?.metadata?.merchant,
                userid: element?.metadata?.userid,
                amount: element?.metadata?.amount,
                currency: element?.metadata?.currency,
                paymentSystem: element?.metadata?.paymentSystem,
                failReason: element?.metadata?.failReason,
                subject: [],
            });
        });

        return result;
    }
    checkForNumbers(str) {
        if (!str) {
            return false;
        }
        const data = str.replace(/[0-9]/g, '');
        if (!data) {
            return true;
        }
        return false;
    }
    getFilteredTransactions(body: any): any {
        if (this.checkForNumbers(body.depositId)) {
            body.depositId = Number(body.depositId);
        }

        return this._httpClient.post(`${this.api}/withdraw/list`, body).pipe(
            catchError((error: any): any => {
                throw new Error(error.message);
            }),
            map((response: any) => {
                let result: any = [];

                result = this.mapResult(response?.data?.actions);
                return result;
            })
        );
    }
    closetransaction(body) {
        return this._httpClient.post(`${this.api}/withdraw/cancel`, body).pipe(
            catchError((error: any): any => {
                throw new Error(error.message);
            }),
            map((response: any) => {
                return response;
            })
        );
    }
    confirmtransaction(body) {
        return this._httpClient.post(`${this.api}/withdraw/confirm`, body).pipe(
            catchError((error: any): any => {
                throw new Error(error.message);
            }),
            map((response: any) => {
                return response;
            })
        );
    }

    confirmManualtransaction(body) {
        return this._httpClient.post(`${this.api}/withdraw/manual`, body).pipe(
            catchError((error: any): any => {
                throw new Error(error.message);
            }),
            map((response: any) => {
                return response;
            })
        );
    }
    splitTransaction(body: any, transaction: any) {
        return this._httpClient
            .post(`${this.api}/withdraw/split`, { body, transaction })
            .pipe(
                catchError((error) => {
                    throw new Error(error.error.message);
                })
            );
    }

    getWithdrawHistory(withdrawId: string) {
        return this._httpClient
            .get(`${this.api}/withdraw/history/${withdrawId}`)
            .pipe(
                catchError((error) => {
                    throw new Error(error.error.message);
                })
            );
    }

    getWithdrawHistorybyIban(iban: string, startDate: string, endDate: string) {
        return this._httpClient
            .get(
                `${this.api}/withdraw/success/iban?iban=${iban}&startDate=${startDate}&endDate=${endDate}`
            )
            .pipe(
                catchError((error) => {
                    throw new Error(error.error.message);
                })
            );
    }
}
